module.exports = __webpack_public_path__ + "img/kibun-@1.cf204fba.svg";